import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LOGO_FULL } from "../data/content";

export const BootLoader = ({ onDone }) => {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => { setShow(false); onDone?.(); }, 2600);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
          className="fixed inset-0 z-[100] bg-[#030305] flex items-center justify-center"
          data-testid="boot-loader"
        >
          <div className="absolute inset-0 grid-bg opacity-40" />
          <div className="relative text-center">
            <motion.div
              initial={{ scale: 1.7, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
              className="inline-flex items-center justify-center rounded-2xl bg-white px-10 py-8 shadow-[0_0_60px_rgba(0,240,255,0.25)]"
            >
              <img src={LOGO_FULL} alt="MACAS BV — Glashelder Project Management" className="h-64 sm:h-80 w-auto" />
            </motion.div>
            <div className="mt-8 w-48 h-0.5 mx-auto bg-white/10 rounded-full overflow-hidden">
              <motion.div
                initial={{ width: 0 }}
                animate={{ width: "100%" }}
                transition={{ duration: 2.2, ease: "easeInOut" }}
                className="h-full bg-[#00F0FF]"
              />
            </div>
            <div className="mt-3 font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-600">Initializing · 24th century</div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
